import React, { useEffect, useRef, useState } from "react";
import { Dialog } from "primereact/dialog";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { useTranslation } from "react-i18next";
import { ColorPicker } from "primereact/colorpicker";
import dbservice from "../../Utility/DbConnection/dbservice";
import { Toast } from "primereact/toast";
import { FilterMatchMode } from "primereact/api";
import { Dropdown } from "primereact/dropdown";
import dbManagerInterface from "../../Utility/DbConnection/DBManagerInterface";

function MeasuresMetadataDialog({
  measuresMetadata,
  setMeasuresData,
  visible,
  onHide,
  type,
}) {
  const { t } = useTranslation();
  const [apiName, setApiName] = useState("");
  const toast = useRef(null);

  useEffect(() => {
    console.log("MEASURE DIALOG OPENED", measuresMetadata);
    switch (type) {
      case "alarms":
        break;
      case "event":
        //setApiName("Automata/Events/GetEventsMetadataWithDescriptions");
        break;
      case "endProcess":
        break;
      case "curves":
        setApiName("Automata/Curves/SetCurveColor");
        break;
      case "realtime":
        setApiName("Automata/RealTime/SaveRealTimeMetaData");
        break;
      default:
        break;
    }
  }, [visible, type]);

  const [machineOptions, setMachineOptions] = useState([]);
  const [graphTypeOptions, setGraphTypeOptions] = useState([]);

  const [filters, setFilters] = useState({
    Machine: { value: null, matchMode: FilterMatchMode.EQUALS },
    Name: { value: null, matchMode: FilterMatchMode.CONTAINS },
    EnDescr: { value: null, matchMode: FilterMatchMode.CONTAINS },
    UM: { value: null, matchMode: FilterMatchMode.CONTAINS },
    GraphType: { value: null, matchMode: FilterMatchMode.EQUALS },
    Min: { value: null, matchMode: FilterMatchMode.CONTAINS },
    Max: { value: null, matchMode: FilterMatchMode.CONTAINS },
    Color: { value: null, matchMode: FilterMatchMode.CONTAINS },
  });

  useEffect(() => {
    if (measuresMetadata != null && measuresMetadata.length > 0) {
      const machineOptions = [
        ...new Set(measuresMetadata.map((item) => item.Machine)),
      ].map((machine) => ({ label: machine, value: machine }));
      setMachineOptions(machineOptions);
      const graphTypeOptions = [
        ...new Set(measuresMetadata.map((item) => item.GraphType)),
      ].map((graphType) => ({ label: graphType, value: graphType }));
      setGraphTypeOptions(graphTypeOptions);
    }
  }, [visible]);

  const machineFilterTemplate = (options) => {
    return (
      <Dropdown
        value={options.value}
        options={machineOptions}
        onChange={(e) => {
          options.filterCallback(e.value, options.index);
          const newFilters = { ...filters };
          newFilters.Machine.value = e.value;
          setFilters(newFilters);
        }}
        className="p-column-filter"
        showClear
        filter
      />
    );
  };

  const graphTypeFilterTemplate = (options) => {
    return (
      <Dropdown
        value={options.value}
        options={graphTypeOptions}
        onChange={(e) => {
          options.filterCallback(e.value, options.index);
          const newFilters = { ...filters };
          console.log(newFilters);
          newFilters.GraphType.value = e.value;
          setFilters(newFilters);
        }}
        className="p-column-filter"
        showClear
        filter
      />
    );
  };

  const onChangeColor = (rowData, color) => {
    console.log("onChangeColor", rowData, color);
    const client = sessionStorage.getItem("chosenClient");
    const plant = sessionStorage.getItem("chosenPlant");
    const machine = rowData.Machine;
    const queryParams = `Client=${client}-${plant}&Machine=${machine}`;
    const body = {
      Machine: rowData.Machine,
      Measure: rowData.Name,
      Color: color,
      GroupID: rowData.GroupId || 0,
      CurveOrderNumber: rowData.CurveOrderNumber || 0,
    };
    dbManagerInterface.SendPostRequest(
      apiName,
      JSON.stringify(body),
      (resData) => {
        if (!resData.success || resData.data?.length === 0) {
          toast.current.show({
            severity: "warn",
            summary: t("warning"),
            detail: t("warning1"),
            life: 3000,
          });
        } else {
          toast.current.show({
            severity: "success",
            summary: t("success"),
            detail: t("success1"),
            life: 3000,
          });
          rowData.Color = color;
        }
      },
      (error) => {
        console.error("error", error);
      },
      toast.current,null,queryParams
    );
  };

  return (
    <Dialog
      header={
        <div style={{ display: "flex", alignItems: "center" }}>
          <i className="pi pi-cog" style={{ marginRight: "0.5rem" }}></i>
          {t("measuresDetails")}
        </div>
      }
      visible={visible}
      onHide={onHide}
      style={{ width: "100%" }}
    >
      <Toast ref={toast} />
      <DataTable
        value={measuresMetadata}
        stripedRows
        paginator
        rows={10}
        filters={filters}
        onFilter={(e) => {
          setFilters(e.filters);
        }}
      >
        <Column
          field="Machine"
          header={t("machine")}
          sortable
          filter
          filterElement={machineFilterTemplate}
          showFilterMenu={false}
        />
        <Column field="Name" header={t("name")} sortable filter></Column>
        <Column
          field="EnDescr"
          header={t("description")}
          sortable
          filter
        ></Column>
        <Column field="UM" header={t("unit")} sortable filter></Column>
        <Column
          field="GraphType"
          header={t("type")}
          sortable
          filter
          filterElement={graphTypeFilterTemplate}
          showFilterMenu={false}
        />

        <Column field="Min" header={t("min")} sortable filter></Column>
        <Column field="Max" header={t("max")} sortable filter></Column>
        <Column
          field="Color"
          header={t("color")}
          sortable
          body={(rowData) => {
            let tempColor = rowData.Color; // Temporary variable to track color changes

            const handleColorChange = (e) => {
              tempColor = e.value; // Update the temporary color value
            };

            const handleColorPickerHide = () => {
              const updatedRow = { ...rowData, Color: tempColor };
              onChangeColor(updatedRow, tempColor); // Call onChangeColor with the final value
            };

            return (
              <ColorPicker
                value={rowData.Color}
                onChange={handleColorChange}
                onHide={handleColorPickerHide}
              />
            );
          }}
        ></Column>

        {/*<Column field="Conversion" header={t("scaling")} sortable></Column>*/}
      </DataTable>
    </Dialog>
  );
}

export default MeasuresMetadataDialog;
